// extracted by mini-css-extract-plugin
export default {"card":"BarChartCard_card__hIUtj","title":"BarChartCard_title__pKmwf","chartContainer":"BarChartCard_chartContainer__zCKmD"};